import { useEffect, useRef } from 'react';
import { useAuth } from '@/hooks/useAuth';

export function LogoutPage() {
  const { logout } = useAuth();
  const hasLoggedOut = useRef(false);

  useEffect(() => {
    // Only logout once, even if component re-renders
    if (!hasLoggedOut.current) {
      hasLoggedOut.current = true;
      logout();
    }
  }, [logout]);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <p className="text-gray-600 dark:text-gray-400">Déconnexion en cours...</p>
      </div>
    </div>
  );
}
